import { useQuery } from '@tanstack/react-query';
import { getSubareaInstitutions } from '../queries/institutions';

type FetchSubareaInstitutionsParams = {
  slug?: string;
  selectedYear?: string[];
  exerciseType?: string | null;
  difficulty?: string[];
  questionOptions?: string[];
  favorite?: boolean;
  unanswered?: boolean;
  rightAnswer?: boolean;
  wrongAnswer?: boolean;
  selectedSubjects?: string[];
  enabled?: boolean;
};

function useFetchSubareaInstitutions(params?: FetchSubareaInstitutionsParams) {
  const { data, isError, error, isSuccess, isPending, refetch } = useQuery({
    queryKey: [
      'fetch-subarea-institutions',
      params?.slug ?? '',
      params?.selectedYear ?? [],
      params?.exerciseType ?? null,
      params?.difficulty ?? [],
      params?.questionOptions ?? [],
      params?.favorite ?? false,
      params?.unanswered ?? false,
      params?.rightAnswer ?? false,
      params?.wrongAnswer ?? false,
      params?.selectedSubjects ?? [],
    ],
    queryFn: () => getSubareaInstitutions({
      slug: params?.slug ?? '',
      selectedYear: params?.selectedYear,
      exerciseType: params?.exerciseType,
      difficulty: params?.difficulty,
      questionOptions: params?.questionOptions,
      favorite: params?.favorite,
      unanswered: params?.unanswered,
      rightAnswer: params?.rightAnswer,
      wrongAnswer: params?.wrongAnswer,
      selectedSubjects: params?.selectedSubjects,
    }),
    retry: false,
    refetchOnWindowFocus: false,
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 10,
    enabled: params?.enabled !== false && !!params?.slug,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    error,
    isSuccess,
    refetch,
  };
}

export { useFetchSubareaInstitutions };
